define('controllers/organization-card',['require','chaplin','models/modals/organization/index','views/modals/organization/index'],function(require) {
    'use strict';

    var Chaplin = require('chaplin'),
        OrganizationModalModel = require('models/modals/organization/index'),
        OrganizationModalView = require('views/modals/organization/index');


    function openOrganizationCard(organizationId) {

        var model = new OrganizationModalModel({
            id: organizationId
        });

        return new OrganizationModalView({ model: model });

    }


    Chaplin.mediator.setHandler('openOrganizationCard', openOrganizationCard);

});
